export enum collectionListItem {
  DELETE = 'saved_cart_delete',
  SCREENREADER_DETAILS = 'screenreader_collection_product_details',
  DETAILS = 'collection_product_details',
}
